module.exports = require("./../../_gen/starling/utils/MathUtil");